module.exports = {  
    bindings: { 
        autoFocus: '<',
        regionCode: '<',
        possibleCountryRegions: '<',
        selectionChanged: '&',
        validation: '<' 
    },
    controller: countryRegionPickerController,
    templateUrl: 'geography/components/country-region-picker.html'
};

countryRegionPickerController.$inject = ['$element', '$timeout'];

function countryRegionPickerController($element, $timeout) {
    var vm = {
        $onInit: attached,
        $postLink: postLink,
        clear: clear,
        region: null,
        itemSelected: itemSelected,
        onBlur: onBlur,
        onEnter: onEnter,
    };

    return vm;

    function attached() {
        if (vm.regionCode) {
            vm.region = _.find( vm.possibleCountryRegions, function(region) {
                return region.code === vm.regionCode;
            });
        }
    }

    function postLink() {
        if (vm.autoFocus) {
            $timeout(function(){
                var rootEl = $element[0];
                var inputEl = rootEl.getElementsByClassName('js-autofocus')[0];
                inputEl.focus();
            }, 0);
        }
    }

    function clear() {
        vm.region = null;
        clearSelection();
    }

    function clearSelection() {
        if (vm.selectionChanged)
            vm.selectionChanged({ region: null });            
    }

    function onBlur() {
        if (!vm.region) {
            clearSelection();
        }
    }

    function onEnter() {
        if (!vm.region) {
            clearSelection();
        }
    }

    function itemSelected(item, model) {
        if (vm.selectionChanged) {
            vm.selectionChanged({ region: item });
        }
    }

}
